// extracted by mini-css-extract-plugin
export default {"header":"Cabecalho_header__keE1b"};